import { IBaseEntity } from '@easy-lib/modules/shared/models/base.model';
import {
	EasyState,
	EasyValidityTypeCode,
	OmsOrderStates,
	Side
} from '@easy-lib/modules/order/oms/models/orderModels.model';
import { OrderConstants, OrderModelType } from '@easy-lib/constants/order.constants';

export interface IBaseOrder {
	side?: Side;
	quantity?: number;
	price?: number;
	symbolIsin?: string;
	orderModelType?: OrderModelType;
}

export interface IBaseOMSOrder extends IBaseOrder {
	validityType?: EasyValidityTypeCode;
	validityDate?: string;
}

export interface IBaseOrderEntity extends IBaseOrder, IBaseEntity {
	validityType?: EasyValidityTypeCode;
	validityDate?: string;
	symbolName?: string;
	errorDescription?: string;
	easyState?: EasyState;
	isBuy;
	isSell;
	sideClass;
	IsDeleteValid;
	IsInErrorState;
	get IsSelectable();
	get sideTitle();
	get OrderTypeTitle();
	get OrderTypeTitleClass();
	IsEditValid?: boolean;
	StateClass?;
	StateNotificationClass?;
	StateNotificationText?;
	IsWaiting?: boolean;
	orderState?: OmsOrderStates;
	ExecutedQuantity?;
	RemainingQuantity?;
	referenceId?: string;
	ExecutedPercent?;
}

export abstract class BaseOrderEntity<T> implements IBaseOrderEntity {
	constructor(obj: Partial<T>) {
		Object.assign(this, obj);
	}
	referenceId?: string;
	orderState?: OmsOrderStates;
	side?: Side;
	quantity?: number;
	price?: number;
	symbolIsin?: string;
	orderModelType?: OrderModelType;
	id?: string;
	createDateTime?: string;
	validityType?: EasyValidityTypeCode;
	validityDate?: string;
	symbolName?: string;
	errorDescription?: string;
	easyState?: EasyState;
	get isBuy(): boolean {
		return this.side === Side.Buy;
	}
	get isSell(): boolean {
		return this.side === Side.Sell;
	}
	get sideClass() {
		return this.side === Side.Sell ? OrderConstants.OrderSideSellClass : OrderConstants.OrderSideBuyClass;
	}

	get sideTitle() {
		return this.side === Side.Sell ? 'فروش' : 'خرید';
	}

	get OrderTypeTitleClass() {
		let className = '';
		switch (this.orderModelType) {
			case OrderModelType.draft:
				className = 'text-warning';
				break;
			case OrderModelType.offline:
				className = `text-global`;
				break;
			case OrderModelType.oms:
				if (this.side === Side.Buy) className = `text-success`;
				else className = `text-danger`;
				break;
		}
		return className;
	}

	get OrderTypeTitle() {
		let title = '';
		switch (this.orderModelType) {
			case OrderModelType.draft:
				title = ` پیش‌نویس ${this.sideTitle}`;
				break;
			case OrderModelType.offline:
				title = `${this.sideTitle} آفلاین `;
				break;
			case OrderModelType.oms:
				title = ` سفارش ${this.sideTitle}`;
				break;
		}
		return title;
	}

	get IsDeleteValid() {
		return true;
	}
	get IsInErrorState() {
		return false;
	}

	get IsSelectable() {
		return true;
	}
}
